import { useState, useEffect, useRef, useCallback } from 'react';
import 'swiper/css';
import { useNavigate, useLocation } from 'react-router-dom';
import Dropdown from '../../Components/CustomDropdown/customdropdown';
import DropdownTest from '../../Components/CustomDropdown/ndrop';
import { useToast } from '../../Utils/toastContext';
import { changeAgentTabFalse } from '../../Redux/store/selectedCard';
import { useDispatch, useSelector } from 'react-redux';
import { clearAgentName } from '../../Redux/store/userSlice';
import { setOnboardingCustomer } from '../../Redux/store/onboardingFormSlice';
import { debounce } from 'lodash';
import AddressAutocomplete from '../../Components/addressInput/address-input';
import countriesData from '../../Data/CountryCodes.json';
import { setAvailableRoleList } from '../../Redux/store/userSlice';
import { Ban, RotateCcw, UserRoundX } from 'lucide-react';
import { formatDateTimeUTC } from '../../Constants/helper-functions';

const validator = require('validator');

const AgentList = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const roleName = useSelector((state) => state.user.roleName);
  const availableRoles = useSelector((state) => state.user.availableRoles);
  const isAgentRedux = availableRoles?.some((r) => r.name === 'agent');
  const [isAgent, setIsAgent] = useState(isAgentRedux);

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showRecords, setShowRecords] = useState(10);
  const [customers, setCustomers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(0);
  const [filterText, setFilterText] = useState('created_at');
  const [totalCount, settotalCount] = useState(0);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSendMessageOpen, setIsSendMessageOpen] = useState(false);
  const [istemplateOpen, setIstemplateOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [isNewChange, setisNewChange] = useState(true);
  const [startAmount, setStartAmount] = useState(0);
  const [endAmount, setEndAmount] = useState(0);
  const [isToUser, setToUser] = useState(false);
  const [isFileExisted, setIsFileExisted] = useState(false);
  const [file, setFile] = useState(null);
  const [redRegCountry, setRegCountry] = useState(null);
  const [redRegCity, setRegCity] = useState(null);
  const [redRegState, setRegState] = useState(null);
  const [newFile, setnewFile] = useState(null);
  const [currentFile, setCurrentFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentDoc, setCurrentDoc] = useState(null);
  const [isDocDelete, setIsDocDelete] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const buttonRefs = useRef({});
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'desc',
  });
  const [agentId, setAgentId] = useState(null);
  const addCustomerRef = useRef();
  const [customerFirstName, setCustomerFirstName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [selectedCode, setSelectedCode] = useState('+61');
  const [customerLastName, setCustomerLastName] = useState('');
  const [countries, setCountries] = useState([]);
  const [email, setEmail] = useState('');
  const [focus, setFocus] = useState(false);
  const [isOpenNewCustomer, setIsOpenNewCustomer] = useState(false);
  const clearAllCustomerFields = () => {
    setCustomerFirstName('');
    setSelectedCode('+61');
    setMobileNumber('');
    setCustomerLastName('');
    setEmail('');
  };
  const handlePendingClick = () => {
    //  setFilter("to_review");
    setIsDropdownOpen((prevState) => !prevState); // Toggle dropdown
  };
  const togglePopupAddCustomer = () => {
    clearAllCustomerFields();
    setIsOpenNewCustomer(!isOpenNewCustomer);
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleFileChange = (e) => {
    if (file) {
      setIsFileExisted(true);
      setCurrentFile(e.target.files[0]);
      return;
    } else {
      setnewFile(e.target.files[0]);
    }
  };
  const getInitials = (name) => {
    if (!name) return '?';
    return name.trim().charAt(0).toUpperCase();
  };

  const getAvatarStyle = (name) => {
    const styles = [
      'bg-[#EEF2FF] text-[#3730A3] ring-1 ring-[#E0E7FF]', // Indigo soft
      'bg-[#F1F5F9] text-[#334155] ring-1 ring-[#E2E8F0]', // Slate
      'bg-[#FDF2F8] text-[#9D174D] ring-1 ring-[#FBCFE8]', // Rose subtle
      'bg-[#F0FDF4] text-[#166534] ring-1 ring-[#BBF7D0]', // Green subtle
      'bg-[#FFFBEB] text-[#92400E] ring-1 ring-[#FDE68A]', // Amber subtle
    ];

    const index = name?.charCodeAt(0) % styles.length;
    return styles[index];
  };
  function formatDateTime(dateString) {
    if (!dateString) return '-';

    try {
      // remove timezone abbreviations like AEDT, AEST etc.
      const cleaned = dateString.replace(/\b[A-Z]{3,4}\b/g, '').trim();

      const parts = cleaned.split(' ');
      const [day, month, year] = parts[0].split('/');

      let [hour, min, sec] = parts[1].split(':');
      const period = parts[2];

      hour = parseInt(hour);

      // convert 12h → 24h
      if (period === 'PM' && hour !== 12) hour += 12;
      if (period === 'AM' && hour === 12) hour = 0;

      return `${day}/${month}/${year} | ${hour
        .toString()
        .padStart(2, '0')}:${min}:${sec}`;
    } catch (e) {
      return '-';
    }
  }
  useEffect(() => {
    updateFile();
  }, [newFile]);
  const updateFile = () => {
    const selectedFile = newFile;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        [
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFile(selectedFile);
      } else {
        showToast(
          'File must be doc or docx format and must be less than 10MB',
          'error',
        );

        setIsFileExisted(false);
      }
    }
  };
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const documents = [
    {
      id: 1,
      name: 'test Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 2,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 3,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 4,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 5,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 6,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 7,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 8,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 9,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    {
      id: 10,
      name: 'Customer Signature.doc',
      date: '22-01-2024 | 4.56 PM',
      size: '122.4 KB',
      icon: '/word-icon.svg',
    },
    // Add more documents as needed
  ];
  const handleAddAgent = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postInviteAPI();
        if (response.status === 201) {
          getCustomers();
          setIsOpenNewCustomer(false);
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [
      email,
      customerFirstName,
      customerLastName,
      selectedCode,
      mobileNumber,
      redRegCity,
      redRegCountry,
      redRegState,
    ], // Dependencies
  );
  const postAgentAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agency/roles/self-grant`;
    const bodyData = {
      role_id: 7, ///6 for compliance
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const deleteRole = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/agency/roles/self-grant/agent`;

    const bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleMarkAgent = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = isAgent ? await deleteRole() : await postAgentAPI();
        if (response.status === 200) {
          getCustomers();
          dispatch(setAvailableRoleList(response.data.roles));
          let isag = response.data.roles?.some((r) => r.name === 'agent');
          console.log('isag+', isag);
          setIsAgent(isag);
          toastMessage = { message: response.message, type: 'success' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [isAgent], // Dependencies
  );
  const togglePopup = () => setIsOpen(!isOpen);
  const toggleSendMessagePopup = () => setIsSendMessageOpen(!isSendMessageOpen);
  const toggleAddTemplatePopup = () => {
    setIstemplateOpen(!istemplateOpen);
  };
  const [recipients, setRecipients] = useState([
    'Jason Quest',
    'Brian Vaughan',
  ]);
  const [suggestions] = useState([
    'Brian Vaughan',
    'Brian Edmon',
    'Colin Simpson',
  ]);
  const [inputValue, setInputValue] = useState(''); // Track the input value

  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const [filteredSuggestions, setFilteredSuggestions] = useState(suggestions); // Store filtered suggestions
  const [showSuggestions, setShowSuggestions] = useState(false); // Control dropdown visibility
  const [registeredAddress, setRegisteredAddress] = useState('');

  const handleAddRecipient = (recipient) => {
    setRecipients([...recipients, recipient]);
    setInputValue(''); // Clear the input field
    setShowSuggestions(false); // Hide the dropdown after selection
  };
  const postInviteAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let payloadRegAddress = {
      address_line_1:
        registeredAddress.street == ''
          ? registeredAddress.full
          : registeredAddress.street,
      address_line_2: registeredAddress.route,
      city_id: redRegCity,
      state_id: redRegState,
      country_id: redRegCountry,
      zip_code: registeredAddress.zip,
      google_address: registeredAddress.full,
    };
    if (payloadRegAddress.city_id === null) {
      showToast('Please enter valid address', 'error');
      return; // Stop execution if city_id is missing
    }
    const apiUrl = `${BASE_URL}/api/v1/agency/agents/invite`;
    const bodyData = {
      first_name: customerFirstName,
      last_name: customerLastName,
      email_address: email,
      mobile_number: mobileNumber,
      country_code: selectedCode,
      address: payloadRegAddress,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const getLocation = async (country, state, city) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/location/ids`;

    let bodyData = {
      country: country,
      state: state,
      city: city,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };

  const handleRemoveRecipient = (index) => {
    const updatedRecipients = [...recipients];
    updatedRecipients.splice(index, 1);
    setRecipients(updatedRecipients);
  };
  const handleScroll = (indexToRemove) => {
    setIsDropdownOpen(false);
  };
  const handleInputChangeAddRecipient = (e) => {
    const value = e.target.value;
    setInputValue(value);
    // Filter suggestions based on the input value
    const filtered = suggestions.filter((suggestion) =>
      suggestion.toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredSuggestions(filtered);
    setShowSuggestions(value.trim().length > 0);
  };
  const [selectedOption, setSelectedOption] = useState(null); // State to hold selected option

  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  const handleAddRecipientButton = () => {
    if (filteredSuggestions.includes(inputValue.trim())) {
      handleAddRecipient(inputValue.trim());
    }
  };
  const navigate = useNavigate();
  const location = useLocation();
  const [filter, setFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const filterOptions = [
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 30, label: '30' },
    { value: 50, label: '50' },
  ];

  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: '10',
  });

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedCustomers([]); // Deselect all
    } else {
      setSelectedCustomers(customers.map((customer) => customer.id)); // Select all
    }
    setSelectAll(!selectAll); // Toggle Select All state
  };
  const updateApplication = async (action, agencyId, reason) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      action == 'block'
        ? `${BASE_URL}/api/v1/agency/agents/${agencyId}/block`
        : `${BASE_URL}/api/v1/agency/agents/${agencyId}/unblock`;
    const bodyData = {
      reason: reason,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleUpdateApplication = useCallback(
    debounce(async (e, action, agentId, reason = null) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateApplication(action, agentId, reason);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          getCustomers();
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [reason], // Dependencies
  );
  const handleFilterChange = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setpreSelectedFilter(selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const toggleTableSelection = (customerId) => {
    setSelectedCustomers(
      (prevSelected) =>
        prevSelected.includes(customerId)
          ? prevSelected.filter((id) => id !== customerId) // Remove if already selected
          : [...prevSelected, customerId], // Add if not selected
    );
  };
  const headers = [
    { label: 'Name', key: 'full_name' },
    { label: 'Email', key: 'email_address' },
    { label: 'Status', key: 'status' },
    { label: 'Date & Time', key: 'created_at' }, // No sorting for actions
    { label: 'Action', key: '' }, // No sorting for actions
  ];
  const reviewHeaders = [
    { label: 'Name', key: 'full_name' },
    { label: 'Email', key: 'email_address' },
    { label: 'Status', key: 'status' },

    { label: 'Date & Time', key: 'created_at' }, // No sorting for actions
    { label: 'Action', key: '' }, // No sorting for actions
  ];
  const pendingHeaders = [
    { label: 'Name', key: 'full_name' },
    { label: 'Email', key: 'email_address' },
    { label: 'Status', key: 'status' },

    { label: 'Date & Time', key: 'created_at' }, // No sorting for actions
  ];
  const handleBlur = () => {};
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === 'object' && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };

  const handleSort = (key) => {
    setFilterText(key);
    setSortConfig((prev) => ({
      key: key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };
  const formatNumber = (value) => {
    // Format number with commas and two decimal places
    return Number(value).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click happened outside all dropdowns
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target),
      );

      if (isOutside) {
        setIsDropdownOpen(false); // Close dropdown if clicked outside
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);
  const getAllLocationDetailsReg = async () => {
    try {
      const response = await getLocation(
        registeredAddress.country &&
          registeredAddress.country.name &&
          registeredAddress.country.name !== ''
          ? registeredAddress.country.name
          : registeredAddress.country,
        registeredAddress.state &&
          registeredAddress.state.name &&
          registeredAddress.state.name !== ''
          ? registeredAddress.state.name
          : registeredAddress.state,
        registeredAddress.city &&
          registeredAddress.city.name &&
          registeredAddress.city.name !== ''
          ? registeredAddress.city.name
          : registeredAddress.city,
      );
      setRegCountry(response.country_id);
      setRegState(response.state_id);
      setRegCity(response.city_id);
    } catch (err) {
      setRegCountry(null);
      setRegState(null);
      setRegCity(null);
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    if (
      (registeredAddress && registeredAddress.country) ||
      (registeredAddress && registeredAddress.country.name)
    ) {
      getAllLocationDetailsReg();
    }
  }, [registeredAddress]);
  const unformatNumber = (value) => {
    // Remove commas from the formatted number
    return value.replace(/,/g, '');
  };

  const handleInputChange = (e) => {
    const rawValue = e.target.value; // Raw input value
    const numericValue = unformatNumber(rawValue); // Remove formatting

    if (!isNaN(numericValue)) {
      setStartAmount(numericValue); // Save the unformatted value
    }
  };
  const handleInputChangeEndAmount = (e) => {
    const rawValue = e.target.value; // Raw input value
    const numericValue = unformatNumber(rawValue); // Remove formatting

    if (!isNaN(numericValue)) {
      setEndAmount(numericValue); // Save the unformatted value
    }
  };

  const getCustomers = async () => {
    setIsLoading(true);
    const direction = sortConfig.direction;

    try {
      let response = '';
      if (roleName == 'agency_compliance' || roleName == 'agency') {
        response = await GetAPIcalls(
          filter == ''
            ? `/api/v1/agency/agents?search=${searchQuery}&page=${currentPage}&size=${showRecords}&sort_by=${filterText}&sort_order=${direction}`
            : `/api/v1/agency/agents?search=${searchQuery}&page=${currentPage}&size=${showRecords}&status=${filter}&sort_by=${filterText}&sort_order=${direction}`,
        );
      }
      if (roleName == 'auditor') {
        response = await GetAPIcalls(
          filter == ''
            ? `/api/v1/auditor/agents?search=${searchQuery}&page=${currentPage}&size=${showRecords}&sort_by=${filterText}&sort_order=${direction}`
            : `/api/v1/auditor/agents?search=${searchQuery}&page=${currentPage}&size=${showRecords}&status=${filter}&sort_by=${filterText}&sort_order=${direction}`,
        );
      }
      if (response.status == 200) {
        setCustomers(response.data.agents);
        settotalPages(response.data.total_pages);
        settotalCount(response.data.total);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const handleSelectInvestmentManagerAccount = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
  };
  useEffect(() => {
    getCustomers();
  }, [
    searchQuery,
    currentPage,
    showRecords,
    filter,
    filterText,
    sortConfig.direction,
  ]);
  useEffect(() => {
    dispatch(changeAgentTabFalse());
  }, []);
  return (
    <div className="pt-4 p-2">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div
        onScroll={handleScroll}
        className="pt-4  text-xs overflow-x-auto  flex-wrap items-center"
      >
        <div className="flex mb-2 ">
          <button
            onClick={() => setFilter('')}
            className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
              filter === '' ? 'bg-[#375AE7] text-white' : 'bg-white text-black'
            }`}
          >
            All
          </button>
          <button
            onClick={() => setFilter('active')}
            className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
              filter === 'active'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Active
          </button>
          <button
            onClick={() => setFilter('onboarding')}
            className={`px-4 py-2  ${
              filter === 'onboarding'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Onboarding
          </button>
          <button
            onClick={() => setFilter('pending')}
            className={`px-4 py-2  ${
              filter === 'pending'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Pending
          </button>
          <button
            onClick={() => setFilter('to_review')}
            className={`px-4 py-2  ${
              filter === 'to_review'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            To Review
          </button>
          <button
            onClick={() => setFilter('sent_for_resubmit')}
            className={`px-4 py-2  ${
              filter === 'sent_for_resubmit'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Sent for Resubmit
          </button>
          <button
            onClick={() => setFilter('blocked')}
            className={`px-4 py-2 rounded-r-xl ${
              filter === 'blocked'
                ? 'bg-[#375AE7] text-white'
                : 'bg-white text-black'
            }`}
          >
            Blocked
          </button>
        </div>
      </div>
      {roleName == 'agency' &&
        filter != 'invites' &&
        filter != 'to_review' &&
        filter !== 'sent_for_resubmit' &&
        filter !== 'pending' &&
        filter !== 'onboarding' &&
        filter !== 'in_progress' &&
        filter !== 'resubmit' &&
        filter !== 'sent_for_approval' && (
          <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img
                  src="/customer-black.svg"
                  alt="Company Logo"
                  className="mr-3"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Team Member List
                </span>
              </div>

              <div className="relative inline-block flex flex-row gap-4">
                {/* TOGGLE - MARK/REMOVE ME AS AGENT */}

                <div
                  ref={addCustomerRef}
                  className="flex items-center space-x-4"
                >
                  <div className="relative inline-block ">
                    <div
                      className="flex items-center justify-center gap-2 px-4 py-2 border border-[#375AE7] text-[#375AE7] rounded-xl cursor-pointer h-11 w-auto"
                      onClick={() => togglePopupAddCustomer()}
                    >
                      <img
                        src="/Plus.svg"
                        alt="document-download"
                        className="mr-2"
                      />
                      <span>Invite Team Member</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-sm text-gray-600">
                    {isAgent
                      ? 'You are the Team Member'
                      : 'Mark Me as Team Member'}{' '}
                  </span>

                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setLoading(true);
                      handleMarkAgent(e);
                    }}
                    className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition
            ${isAgent ? 'bg-[#375AE7]' : 'bg-gray-300'}
          `}
                  >
                    <span
                      className={`
              inline-block h-4 w-4 transform rounded-full bg-white transition
              ${isAgent ? 'translate-x-6' : 'translate-x-1'}
            `}
                    />
                  </button>
                </div>
              </div>
            </div>
            {isOpenNewCustomer && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[60vh] max-h-screen overflow-y-auto">
                  {/* Modal Header */}
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg font-medium text-center w-full">
                        Invite Team Member
                      </h2>
                      <div className="flex justify-end">
                        <img
                          onClick={togglePopupAddCustomer}
                          src="/add.svg"
                          alt="Add"
                          className="w-10 h-10 cursor-pointer"
                        />
                      </div>
                    </div>
                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                      {/* Left Column */}
                      <div className="space-y-4 pt-4 px-4">
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            First Name
                          </label>{' '}
                          <input
                            id="finInstituition"
                            type="text"
                            value={customerFirstName}
                            onChange={(e) =>
                              setCustomerFirstName(e.target.value)
                            }
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="John Daniel"
                          />
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 mt-4 text-sm text-labelColour"
                          >
                            Mobile Number
                          </label>{' '}
                          <div className="flex  items-center">
                            <select
                              value={selectedCode}
                              onChange={handleCodeChange}
                              onFocus={() => setFocus(true)}
                              onBlur={() => setFocus(false)}
                              className={`w-40  appearance-none border text-black  appearance-none text-sm font-medium rounded-tl-md rounded-tr-none rounded-br-none rounded-bl-md h-[2.813rem]  ${
                                focus
                                  ? 'border-black border-2'
                                  : ' border-gray-300 '
                              } border-r-0   border  py-2 px-1 leading-tight focus:outline-none `}
                              placeholder="AU+61"
                            >
                              {countries.map((country) => (
                                <option
                                  key={country.code}
                                  value={country.dialCode}
                                >
                                  {country.code} {country.dialCode}
                                </option>
                              ))}
                            </select>
                            <input
                              type="tel"
                              id="mobileNumber"
                              value={mobileNumber}
                              onFocus={() => setFocus(true)}
                              onBlur={() => setFocus(false)}
                              onChange={(e) => setMobileNumber(e.target.value)}
                              placeholder="Mobile Number"
                              className={`border text-black text-base font-medium rounded-tr-md rounded-tl-none rounded-bl-none rounded-br-md h-[2.813rem] p-2 ${
                                focus
                                  ? 'border-black border-2'
                                  : ' border-gray-300 '
                              } rounded-md focus:outline-none w-full border-l-0 appearance-none`}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Center Column with Border */}
                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Last Name
                          </label>{' '}
                          <input
                            id="finInstituition"
                            type="text"
                            value={customerLastName}
                            onChange={(e) =>
                              setCustomerLastName(e.target.value)
                            }
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="John Daniel"
                          />
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 mt-4 text-sm text-labelColour"
                          >
                            Email
                          </label>{' '}
                          <input
                            id="finInstituition"
                            type="text"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="John Daniel"
                          />
                        </div>
                      </div>

                      {/* Right Column */}
                      <div className="space-y-4 px-4 pt-4">
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Address
                          </label>{' '}
                          <AddressAutocomplete
                            value={registeredAddress?.full}
                            className="w-full"
                            onSelect={(addr) => {
                              setRegisteredAddress(addr);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                      <button
                        onClick={togglePopupAddCustomer}
                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          if (!validateEmail(email)) {
                            showToast('Please enter a valid email', 'error');
                            return;
                          }
                          if (!customerLastName) {
                            showToast('Please enter last name', 'error');
                            return;
                          }
                          if (
                            !validator.isMobilePhone(
                              selectedCode + mobileNumber,
                              'any',
                            )
                          ) {
                            showToast(
                              'Please enter valid mobile number',
                              'error',
                            );
                            return;
                          }
                          if (!customerFirstName) {
                            showToast('Please enter first name', 'error');
                            return;
                          }

                          setLoading(true);
                          handleAddAgent(e);
                        }}
                        className="px-6 py-2 rounded-lg bg-[#375AE7] text-white"
                      >
                        Send Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilter}
                    onSelect={handleFilterChange}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="p-2 pl-6 text-sm border rounded-xl"
                      placeholder="Search Team Member"
                      value={searchQuery}
                      onChange={(e) => {
                        setCurrentPage(1);
                        setSearchQuery(e.target.value);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {' '}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {/* Table */}
              <div className="overflow-x-auto">
                <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
                  {/* Table Header */}
                  <thead className="text-[#8C8C8C] bg-[#F9F9F9] text-sm">
                    <tr className="mb-4">
                      {/* Dynamic Headers */}
                      {headers.map((header, index) => (
                        <th
                          onClick={() => handleSort(header.key)}
                          key={header.label}
                          className={`
          cursor-pointer font-medium px-4 py-4 border text-left
          ${index === 0 ? 'rounded-l-xl' : ''}
          ${index === headers.length - 1 ? 'rounded-r-xl' : ''}
        `}
                        >
                          <div className="flex items-center justify-between w-full">
                            <span>{header.label}</span>

                            {header.key !== '' && (
                              <img
                                src="/sort.svg"
                                alt="Sort Icon"
                                className="w-4 h-4 ml-auto"
                              />
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {isLoading ? (
                    <tbody className="shimmer-container-list ">
                      {/* Creating 5 rows of shimmer effect */}
                      {[...Array(5)].map((_, rowIndex) => (
                        <tr key={rowIndex} className="shimmer-row-list">
                          {/* Creating 7 cells in each row for shimmer */}
                          {[...Array(10)].map((_, colIndex) => (
                            <td key={colIndex} className="shimmer-cell-list">
                              <div className="shimmer-loader"></div>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody className="text-sm mt-4 font-medium text-black">
                      {customers.length > 0 ? (
                        <>
                          {customers.map((customer) => (
                            <tr
                              key={customer.id}
                              className="px-6 py-2 bg-white"
                            >
                              <td
                                onClick={() => {
                                  if (
                                    customer.status.label == 'suspended' ||
                                    customer.status.label == 'archived' ||
                                    customer.status.label == 'active' ||
                                    filter == 'suspended' ||
                                    filter == 'archived'
                                  ) {
                                    dispatch(clearAgentName());
                                    let redirectState = {
                                      path: `/team-member-details/${customer.user_id}`,
                                      state: {
                                        from: location.pathname,
                                        historyStack: [
                                          ...(location.state?.historyStack ||
                                            []),
                                          location.pathname,
                                        ],
                                      },
                                    };
                                    sessionStorage.setItem(
                                      'redirectAfterLogin',
                                      JSON.stringify(redirectState),
                                    );
                                    navigate(
                                      `/team-member-details/${customer.user_id}`,
                                      {
                                        state: {
                                          from: location.pathname,
                                          historyStack: [
                                            ...(location.state?.historyStack ||
                                              []),
                                            location.pathname,
                                          ],
                                        },
                                      },
                                    );
                                  }
                                  if (
                                    roleName == 'agency' &&
                                    (customer.status.label == 'to_review' ||
                                      customer.status.label == 'in_progress' ||
                                      customer.status.label == 'resubmit' ||
                                      customer.status.label ===
                                        'sent_for_resubmit' ||
                                      customer.status.label ===
                                        'sent_for_approval')
                                  ) {
                                    dispatch(
                                      setOnboardingCustomer(customer.user_id),
                                    );
                                    let redirectState = {
                                      path: `/review-kyc-team-member/${customer.user_id}`,
                                      state: {
                                        from: location.pathname,
                                        historyStack: [
                                          ...(location.state?.historyStack ||
                                            []),
                                          location.pathname,
                                        ],
                                      },
                                    };
                                    sessionStorage.setItem(
                                      'redirectAfterLogin',
                                      JSON.stringify(redirectState),
                                    );
                                    navigate(
                                      `/review-kyc-team-member/${customer.user_id}`,
                                      {
                                        state: {
                                          from: location.pathname,
                                          historyStack: [
                                            ...(location.state?.historyStack ||
                                              []),
                                            location.pathname,
                                          ],
                                        },
                                      },
                                    );
                                  }
                                }}
                                className={`${
                                  customer.status.label != 'onboarding' &&
                                  customer.status.label != 'pending'
                                    ? 'cursor-pointer'
                                    : ''
                                } px-4 py-6 border-b border-t border border-r-0 rounded-l-xl text-left min-w-[200px] max-w-[auto] font-medium flex items-center space-x-2`}
                              >
                                <div
                                  className={`w-10 h-10 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                                    customer.full_name,
                                  )}`}
                                >
                                  {getInitials(customer.full_name)}
                                </div>
                                <span
                                  className={`${
                                    customer.status.label != 'onboarding' &&
                                    customer.status.label != 'pending'
                                      ? 'underline cursor-pointer'
                                      : ''
                                  } text-left`}
                                >
                                  {customer.full_name}
                                </span>
                              </td>
                              <td className="px-4 py-2 w-40 border-b border-t relative">
                                {customer.email_address}
                              </td>
                              <td className="px-4 w-20 border-b border-t text-center py-2">
                                <button
                                  className={` w-40 text-center  font-medium h-10 rounded-xl text-xs px-2 py-2  flex justify-center items-center focus:outline-none${
                                    customer.status.label == 'active'
                                      ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                                      : ''
                                  }
                              ${
                                customer.status.label == 'onboarding'
                                  ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                  : ''
                              }
                                 ${
                                   customer.status.label == 'draft'
                                     ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                     : ''
                                 }
                            ${
                              customer.status.label == 'to_review'
                                ? ' text-[#F77E27] bg-[#F77E27] bg-opacity-20'
                                : ''
                            }
                                ${
                                  customer.status.label == 'in_progress'
                                    ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                    : ''
                                }
                                 ${
                                   customer.status.label == 'pending'
                                     ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                     : ''
                                 }
                                ${
                                  customer.status.label == 'resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_approval'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                  ${
                                    customer.status.label == 'rejected'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
                                    ${
                                      customer.status.label == 'blocked'
                                        ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                        : ''
                                    }
                                   ${
                                     customer.status.label == 'deleted'
                                       ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                       : ''
                                   }
                               ${
                                 customer.status.label == 'suspended'
                                   ? ' text-white bg-[#FF5050]'
                                   : ''
                               }
                               ${
                                 customer.status.label == 'closed'
                                   ? ' text-[#000000] bg-[#000000] bg-opacity-20'
                                   : ''
                               }
                                ${
                                  customer.status.label == 'archived'
                                    ? ' text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20'
                                    : ''
                                }
                              `}
                                >
                                  <span className="mr-6 text-center">
                                    {customer.status?.label
                                      .replace(/_/g, ' ')
                                      .replace(/\b\w/g, (char) =>
                                        char.toUpperCase(),
                                      )}
                                  </span>
                                </button>
                              </td>
                              <td className="px-4 py-2 border-b border-t  border-r-0  border-l-0 text-ellipsis border overflow-hidden whitespace-nowrap">
                                <div className="flex items-center px-2 space-x-2">
                                  <img
                                    src="/clock.svg"
                                    alt="Time Icon"
                                    className="h-4 w-4"
                                  />
                                  <span className="rounded-xl">
                                    {formatDateTimeUTC(customer.created_at)}
                                  </span>
                                </div>
                              </td>
                              <td className="px-4 py-3 border-b border-t border-l-0 rounded-r-xl border rounded-r">
                                <div className="flex items-center gap-2">
                                  {/* BLOCK */}
                                  {customer.status?.label !== 'blocked' && (
                                    <button
                                      onClick={() => {
                                        setSelectedUserId(customer.user_id);
                                        setReason('');
                                        setError('');
                                        setShowBlockModal(true);
                                      }}
                                      className="
  group inline-flex items-center gap-1.5 rounded-full
  border border-slate-200 bg-white px-3.5 py-1.5
  text-xs sm:text-sm font-medium text-slate-700
  shadow-sm transition-all duration-200
  hover:border-[#375AE7] hover:text-[#375AE7]
  hover:bg-[#375AE7]/5 hover:shadow-md active:scale-95
  "
                                    >
                                      <Ban size={14} />
                                      Block
                                    </button>
                                  )}

                                  {/* UNBLOCK */}
                                  {customer.status?.label === 'blocked' && (
                                    <button
                                      onClick={(e) => {
                                        setLoading(true);
                                        handleUpdateApplication(
                                          e,
                                          'unblock',
                                          customer.user_id,
                                        );
                                      }}
                                      className="
        group
        inline-flex
        items-center
        gap-1.5
        rounded-full
        border
        border-slate-200
        bg-white
        px-3.5
        py-1.5
        text-xs
        sm:text-sm
        font-medium
        text-slate-700
        shadow-sm
        transition-all
        duration-200
        hover:border-[#375AE7]
        hover:text-[#375AE7]
        hover:bg-[#375AE7]/5
        hover:shadow-md
        active:scale-95
        "
                                    >
                                      <RotateCcw
                                        size={14}
                                        className="transition-transform group-hover:scale-110"
                                      />
                                      Unblock
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </>
                      ) : (
                        <tr>
                          <td colSpan="5">
                            <div className="flex flex-col items-center justify-center py-20 px-6 bg-white rounded-2xl text-center">
                              {/* ICON */}
                              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-blue-50 mb-5">
                                <UserRoundX
                                  className="w-7 h-7 text-[#375AE7]"
                                  strokeWidth={1.8}
                                />
                              </div>

                              {/* TITLE */}
                              <h3 className="text-base font-semibold text-gray-800">
                                No team members available
                              </h3>

                              {/* DESCRIPTION */}
                              <p className="text-sm font-normal text-gray-500 mt-2 max-w-md">
                                {searchQuery
                                  ? `No team members found for "${searchQuery}".`
                                  : 'No team members found. Invite a new team member to get started.'}
                              </p>

                              {/* ACTION BUTTON */}
                              <button
                                onClick={() => {
                                  // navigate or open add member modal
                                  togglePopupAddCustomer();
                                }}
                                className="
            mt-6
            inline-flex items-center gap-2
            px-5 py-2.5
            rounded-xl
            bg-[#375AE7]
            text-white
            text-sm
            font-medium
            shadow-sm
            hover:shadow-md
            hover:bg-[#2f4fd0]
            transition-all
            duration-200
            active:scale-95
          "
                              >
                                <svg
                                  className="w-5 h-5"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M12 4v16m8-8H4"
                                  />
                                </svg>
                                Invite Team Member
                              </button>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </div>

              {customers.length > 0 && (
                <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                  {/* Entries Info Section */}
                  <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                    Showing {showRecords * (currentPage - 1) + 1} to{' '}
                    {currentPage === totalPages || totalPages == 0
                      ? totalCount
                      : Math.max(
                          showRecords * currentPage,
                          customers.length,
                        )}{' '}
                    of {totalCount} entries
                  </div>

                  {/* Pagination Section */}
                  <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                    {/* Previous Button */}
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((prev) => prev - 1)}
                      className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Prev
                    </button>

                    {/* Page Buttons */}
                    {Array.from({ length: Math.min(totalPages, 5) }).map(
                      (_, index) => {
                        const startPage = Math.max(
                          1,
                          Math.min(totalPages - 4, currentPage - 2),
                        );
                        const page = startPage + index;

                        return (
                          <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`px-3 py-1 rounded ${
                              currentPage === page
                                ? 'bg-[#375AE7] text-white'
                                : 'bg-white border border-gray-300 text-black'
                            }`}
                          >
                            {page}
                          </button>
                        );
                      },
                    )}

                    {/* Next Button */}
                    <button
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                      className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

      {roleName == 'agency' &&
        (filter == 'to_review' ||
          filter == 'in_progress' ||
          filter == 'resubmit' ||
          filter === 'sent_for_resubmit' ||
          filter === 'sent_for_approval') && (
          <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img
                  src="/profile-black.svg"
                  alt="Company Logo"
                  className="mr-3"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Team Member List
                </span>
              </div>
            </div>
            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilter}
                    onSelect={handleFilterChange}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="p-2 pl-6 text-sm border rounded-xl w-full sm:w-80 md:w-96 lg:w-[420px]"
                      placeholder="Search Customer"
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {' '}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {/* Table */}
              <div className="overflow-x-auto">
                <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
                  {/* Table Header */}
                  <thead className="text-[#8C8C8C] bg-[#F9F9F9] text-sm">
                    <tr className="mb-4">
                      {/* Dynamic Headers */}
                      {reviewHeaders.map((header, index) => (
                        <th
                          onClick={() => handleSort(header.key)}
                          key={header.label}
                          className={`
          cursor-pointer font-medium px-4 py-4 border text-left
          ${index === 0 ? 'rounded-l-xl' : ''}
          ${index === reviewHeaders.length - 1 ? 'rounded-r-xl' : ''}
        `}
                        >
                          <div className="flex items-center justify-between w-full">
                            <span>{header.label}</span>

                            {header.key !== '' && (
                              <img
                                src="/sort.svg"
                                alt="Sort Icon"
                                className="w-4 h-4 ml-auto"
                              />
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {isLoading ? (
                    <tbody className="shimmer-container-list ">
                      {/* Creating 5 rows of shimmer effect */}
                      {[...Array(5)].map((_, rowIndex) => (
                        <tr key={rowIndex} className="shimmer-row-list">
                          {/* Creating 7 cells in each row for shimmer */}
                          {[...Array(10)].map((_, colIndex) => (
                            <td key={colIndex} className="shimmer-cell-list">
                              <div className="shimmer-loader"></div>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody className="text-sm mt-4 font-medium text-black">
                      {customers.length > 0 ? (
                        <>
                          {' '}
                          {customers.map((customer) => (
                            <tr
                              key={customer.id}
                              className="px-6 py-2 bg-[#F9F9F9]"
                            >
                              <td className="px-4 py-4 border-b rounded-l-xl border border-r-0 border-t text-left min-w-[200px] max-w-[400px] font-medium flex items-center space-x-2">
                                <div
                                  className={`w-10 h-10 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                                    customer.full_name,
                                  )}`}
                                >
                                  {getInitials(customer.full_name)}
                                </div>
                                <span className="text-left">
                                  {customer.full_name}
                                </span>
                              </td>

                              {/* Dropdown Button */}
                              <td className="px-4 py-2 w-40 border-b border-t relative">
                                {customer.email_address}
                              </td>
                              <td className="px-4 w-20 border-b border-t text-center py-2">
                                <button
                                  className={` w-40 text-center  font-medium h-10 rounded-xl text-xs px-2 py-2  flex justify-center items-center focus:outline-none${
                                    customer.status.label == 'active'
                                      ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                                      : ''
                                  }
                              ${
                                customer.status.label == 'onboarding'
                                  ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                  : ''
                              }
                                 ${
                                   customer.status.label == 'draft'
                                     ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                     : ''
                                 }
                            ${
                              customer.status.label == 'to_review'
                                ? ' text-[#F77E27] bg-[#F77E27] bg-opacity-20'
                                : ''
                            }
                                ${
                                  customer.status.label == 'in_progress'
                                    ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                    : ''
                                }
                                 ${
                                   customer.status.label == 'pending'
                                     ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                     : ''
                                 }
                                ${
                                  customer.status.label == 'resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_approval'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                  ${
                                    customer.status.label == 'rejected'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
                                    ${
                                      customer.status.label == 'blocked'
                                        ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                        : ''
                                    }
                                   ${
                                     customer.status.label == 'deleted'
                                       ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                       : ''
                                   }
                               ${
                                 customer.status.label == 'suspended'
                                   ? ' text-white bg-[#FF5050]'
                                   : ''
                               }
                               ${
                                 customer.status.label == 'closed'
                                   ? ' text-[#000000] bg-[#000000] bg-opacity-20'
                                   : ''
                               }
                                ${
                                  customer.status.label == 'archived'
                                    ? ' text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20'
                                    : ''
                                }
                              `}
                                >
                                  <span className="mr-6 text-center">
                                    {customer.status?.label
                                      .replace(/_/g, ' ')
                                      .replace(/\b\w/g, (char) =>
                                        char.toUpperCase(),
                                      )}
                                  </span>
                                </button>
                              </td>
                              <td className="px-4 py-2 border-b border-t  text-ellipsis overflow-hidden whitespace-nowrap">
                                <div className="flex items-center space-x-2">
                                  <img
                                    src="/clock.svg"
                                    alt="Time Icon"
                                    className="h-4 w-4"
                                  />
                                  <span className="rounded-xl">
                                    {formatDateTimeUTC(customer.created_at)}
                                  </span>
                                </div>
                              </td>
                              <td
                                onClick={() => {
                                  dispatch(
                                    setOnboardingCustomer(customer.user_id),
                                  );
                                  let redirectState = {
                                    path: `/review-kyc-team-member/${customer.user_id}`,
                                    state: {
                                      from: location.pathname,
                                      historyStack: [
                                        ...(location.state?.historyStack || []),
                                        location.pathname,
                                      ],
                                    },
                                  };
                                  sessionStorage.setItem(
                                    'redirectAfterLogin',
                                    JSON.stringify(redirectState),
                                  );
                                  navigate(
                                    `/review-kyc-team-member/${customer.user_id}`,
                                    {
                                      state: {
                                        from: location.pathname,
                                        historyStack: [
                                          ...(location.state?.historyStack ||
                                            []),
                                          location.pathname,
                                        ],
                                      },
                                    },
                                  );
                                }}
                                className="px-4 py-2 border-b border-t rounded-r border-l-0 border rounded-r-xl  text-ellipsis  overflow-hidden whitespace-nowrap"
                              >
                                <span className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl">
                                  Review Application
                                </span>
                              </td>
                            </tr>
                          ))}
                        </>
                      ) : (
                        <tr>
                          <td colSpan="5">
                            <div className="flex flex-col items-center justify-center py-20 px-6 bg-white rounded-2xl text-center">
                              {/* ICON */}
                              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-blue-50 mb-5">
                                <UserRoundX
                                  className="w-7 h-7 text-[#375AE7]"
                                  strokeWidth={1.8}
                                />
                              </div>

                              {/* TITLE */}
                              <h3 className="text-base font-semibold text-gray-800">
                                No team members available
                              </h3>

                              {/* DESCRIPTION */}
                              <p className="text-sm font-normal text-gray-500 mt-2 max-w-md">
                                {searchQuery
                                  ? `No team members found for "${searchQuery}".`
                                  : 'No team members found. Invite a new team member to get started.'}
                              </p>

                              {/* ACTION BUTTON */}
                              <button
                                onClick={() => {
                                  // navigate or open add member modal
                                  togglePopupAddCustomer();
                                }}
                                className="
            mt-6
            inline-flex items-center gap-2
            px-5 py-2.5
            rounded-xl
            bg-[#375AE7]
            text-white
            text-sm
            font-medium
            shadow-sm
            hover:shadow-md
            hover:bg-[#2f4fd0]
            transition-all
            duration-200
            active:scale-95
          "
                              >
                                <svg
                                  className="w-5 h-5"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M12 4v16m8-8H4"
                                  />
                                </svg>
                                Add Team Member
                              </button>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </div>
              {customers.length > 0 && (
                <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                  {/* Entries Info Section */}
                  <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                    Showing {showRecords * (currentPage - 1) + 1} to{' '}
                    {currentPage === totalPages || totalPages == 0
                      ? totalCount
                      : Math.max(
                          showRecords * currentPage,
                          customers.length,
                        )}{' '}
                    of {totalCount} entries
                  </div>

                  {/* Pagination Section */}
                  <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                    {/* Previous Button */}
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((prev) => prev - 1)}
                      className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Prev
                    </button>

                    {/* Page Buttons */}
                    {Array.from({ length: Math.min(totalPages, 5) }).map(
                      (_, index) => {
                        const startPage = Math.max(
                          1,
                          Math.min(totalPages - 4, currentPage - 2),
                        );
                        const page = startPage + index;

                        return (
                          <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`px-3 py-1 rounded ${
                              currentPage === page
                                ? 'bg-[#375AE7] text-white'
                                : 'bg-white border border-gray-300 text-black'
                            }`}
                          >
                            {page}
                          </button>
                        );
                      },
                    )}

                    {/* Next Button */}
                    <button
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                      className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

      {roleName == 'agency' &&
        (filter == 'pending' || filter == 'onboarding') && (
          <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
            <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img
                  src="/profile-black.svg"
                  alt="Company Logo"
                  className="mr-3"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Team Member List
                </span>
              </div>
            </div>
            <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                <div className="flex items-center space-x-2">
                  <span className="lg:text-md  text-sm text-[#8C8C8C]">
                    Show Records
                  </span>
                  <Dropdown
                    label=""
                    options={filterOptions}
                    preselectedValue={preSelectedFilter}
                    onSelect={handleFilterChange}
                  />
                </div>
                <div className="flex items-center">
                  <div className="relative">
                    <input
                      type="text"
                      className="p-2 pl-6 text-sm border rounded-xl w-full sm:w-80 md:w-96 lg:w-[420px]"
                      placeholder="Search Customer"
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                    <span className="absolute left-2 top-3 text-gray-500">
                      {' '}
                      <img
                        src="/search-normal.svg"
                        alt="Company Logo"
                        className="mr-2"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {/* Table */}
              <div className="overflow-x-auto">
                <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
                  {/* Table Header */}
                  <thead className="text-[#8C8C8C] bg-[#F9F9F9] text-sm">
                    <tr className="mb-4">
                      {/* Dynamic Headers */}
                      {pendingHeaders.map((header, index) => (
                        <th
                          onClick={() => handleSort(header.key)}
                          key={header.label}
                          className={`
          cursor-pointer font-medium px-4 py-4 border text-left
          ${index === 0 ? 'rounded-l-xl' : ''}
          ${index === pendingHeaders.length - 1 ? 'rounded-r-xl' : ''}
        `}
                        >
                          <div className="flex items-center justify-between w-full">
                            <span>{header.label}</span>

                            {header.key !== '' && (
                              <img
                                src="/sort.svg"
                                alt="Sort Icon"
                                className="w-4 h-4 ml-auto"
                              />
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>

                  {isLoading ? (
                    <tbody className="shimmer-container-list ">
                      {/* Creating 5 rows of shimmer effect */}
                      {[...Array(5)].map((_, rowIndex) => (
                        <tr key={rowIndex} className="shimmer-row-list">
                          {/* Creating 7 cells in each row for shimmer */}
                          {[...Array(10)].map((_, colIndex) => (
                            <td key={colIndex} className="shimmer-cell-list">
                              <div className="shimmer-loader"></div>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody className="text-sm mt-4 font-medium text-black">
                      {customers.length > 0 ? (
                        <>
                          {' '}
                          {customers.map((customer) => (
                            <tr
                              key={customer.id}
                              className="px-6 py-2 bg-[#F9F9F9]"
                            >
                              <td className="px-4 py-4 border-b border-t text-left border border-r-0 rounded-l-xl font-medium flex items-center space-x-2">
                                <div
                                  className={`w-10 h-10 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                                    customer.full_name,
                                  )}`}
                                >
                                  {getInitials(customer.full_name)}
                                </div>
                                <span className="text-left">
                                  {customer.full_name}
                                </span>
                              </td>

                              {/* Dropdown Button */}
                              <td className="px-4 py-2 w-40 border-b border-t relative">
                                {customer.email_address}
                              </td>
                              <td className="px-4 w-20 border-b border-t text-center py-2">
                                <button
                                  className={` w-40 text-center  font-medium h-10 rounded-xl text-xs px-2 py-2  flex justify-center items-center focus:outline-none${
                                    customer.status.label == 'active'
                                      ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                                      : ''
                                  }
                              ${
                                customer.status.label == 'onboarding'
                                  ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                  : ''
                              }
                                 ${
                                   customer.status.label == 'draft'
                                     ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                     : ''
                                 }
                            ${
                              customer.status.label == 'to_review'
                                ? ' text-[#F77E27] bg-[#F77E27] bg-opacity-20'
                                : ''
                            }
                                ${
                                  customer.status.label == 'in_progress'
                                    ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                    : ''
                                }
                                 ${
                                   customer.status.label == 'pending'
                                     ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                     : ''
                                 }
                                ${
                                  customer.status.label == 'resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_approval'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                  ${
                                    customer.status.label == 'rejected'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
                                    ${
                                      customer.status.label == 'blocked'
                                        ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                        : ''
                                    }
                                   ${
                                     customer.status.label == 'deleted'
                                       ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                       : ''
                                   }
                               ${
                                 customer.status.label == 'suspended'
                                   ? ' text-white bg-[#FF5050]'
                                   : ''
                               }
                               ${
                                 customer.status.label == 'closed'
                                   ? ' text-[#000000] bg-[#000000] bg-opacity-20'
                                   : ''
                               }
                                ${
                                  customer.status.label == 'archived'
                                    ? ' text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20'
                                    : ''
                                }
                              `}
                                >
                                  <span className="mr-6 text-center">
                                    {customer.status?.label
                                      .replace(/_/g, ' ')
                                      .replace(/\b\w/g, (char) =>
                                        char.toUpperCase(),
                                      )}
                                  </span>
                                </button>
                              </td>
                              <td className="px-4 py-2 border-b border-t border border-l-0 rounded-r-xl text-ellipsis overflow-hidden whitespace-nowrap">
                                <div className="flex items-center space-x-2">
                                  <img
                                    src="/clock.svg"
                                    alt="Time Icon"
                                    className="h-4 w-4"
                                  />
                                  <span className="rounded-xl">
                                    {formatDateTimeUTC(customer.created_at)}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </>
                      ) : (
                        <tr>
                          <td colSpan="5">
                            <div className="flex flex-col items-center justify-center py-20 px-6 bg-white rounded-2xl text-center">
                              {/* ICON */}
                              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-blue-50 mb-5">
                                <UserRoundX
                                  className="w-7 h-7 text-[#375AE7]"
                                  strokeWidth={1.8}
                                />
                              </div>

                              {/* TITLE */}
                              <h3 className="text-base font-semibold text-gray-800">
                                No team members available
                              </h3>

                              {/* DESCRIPTION */}
                              <p className="text-sm font-normal text-gray-500 mt-2 max-w-md">
                                {searchQuery
                                  ? `No team members found for "${searchQuery}".`
                                  : 'No team members found. Invite a new team member to get started.'}
                              </p>

                              {/* ACTION BUTTON */}
                              <button
                                onClick={() => {
                                  // navigate or open add member modal
                                  togglePopupAddCustomer();
                                }}
                                className="
            mt-6
            inline-flex items-center gap-2
            px-5 py-2.5
            rounded-xl
            bg-[#375AE7]
            text-white
            text-sm
            font-medium
            shadow-sm
            hover:shadow-md
            hover:bg-[#2f4fd0]
            transition-all
            duration-200
            active:scale-95
          "
                              >
                                <svg
                                  className="w-5 h-5"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M12 4v16m8-8H4"
                                  />
                                </svg>
                                Add Team Member
                              </button>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </div>
              {customers.length > 0 && (
                <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                  {/* Entries Info Section */}
                  <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                    Showing {showRecords * (currentPage - 1) + 1} to{' '}
                    {currentPage === totalPages || totalPages == 0
                      ? totalCount
                      : Math.max(
                          showRecords * currentPage,
                          customers.length,
                        )}{' '}
                    of {totalCount} entries
                  </div>

                  {/* Pagination Section */}
                  <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                    {/* Previous Button */}
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage((prev) => prev - 1)}
                      className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Prev
                    </button>

                    {/* Page Buttons */}
                    {Array.from({ length: Math.min(totalPages, 5) }).map(
                      (_, index) => {
                        const startPage = Math.max(
                          1,
                          Math.min(totalPages - 4, currentPage - 2),
                        );
                        const page = startPage + index;

                        return (
                          <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`px-3 py-1 rounded ${
                              currentPage === page
                                ? 'bg-[#375AE7] text-white'
                                : 'bg-white border border-gray-300 text-black'
                            }`}
                          >
                            {page}
                          </button>
                        );
                      },
                    )}

                    {/* Next Button */}
                    <button
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage((prev) => prev + 1)}
                      className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      {roleName != 'agency' && roleName != 'auditor' && (
        <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
          <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img
                src="/customer-black.svg"
                alt="Company Logo"
                className="mr-3"
              />
              <span className="font-medium lg:text-xl text-sm">
                Team Member List
              </span>
            </div>
          </div>
          <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
            <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
              <div className="flex items-center space-x-2">
                <span className="lg:text-md  text-sm text-[#8C8C8C]">
                  Show Records
                </span>
                <Dropdown
                  label=""
                  options={filterOptions}
                  preselectedValue={preSelectedFilter}
                  onSelect={handleFilterChange}
                />
              </div>
              <div className="flex items-center">
                <div className="relative">
                  <input
                    type="text"
                    className="p-2 pl-6 text-sm border rounded-xl"
                    placeholder="Search Team Member"
                    value={searchQuery}
                    onChange={(e) => {
                      setCurrentPage(1);
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <span className="absolute left-2 top-3 text-gray-500">
                    {' '}
                    <img
                      src="/search-normal.svg"
                      alt="Company Logo"
                      className="mr-2"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div>
            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
                {/* Table Header */}
                <thead className="text-[#8C8C8C] bg-[#F9F9F9] text-sm">
                  <tr className="mb-4">
                    {/* Dynamic Headers */}
                    {headers.map((header, index) => (
                      <th
                        onClick={() => handleSort(header.key)}
                        key={header.label}
                        className={`
          cursor-pointer font-medium px-4 py-4 border text-left
          ${index === 0 ? 'rounded-l-xl' : ''}
          ${index === headers.length - 1 ? 'rounded-r-xl' : ''}
        `}
                      >
                        <div className="flex items-center justify-between w-full">
                          <span>{header.label}</span>

                          {header.key !== '' && (
                            <img
                              src="/sort.svg"
                              alt="Sort Icon"
                              className="w-4 h-4 ml-auto"
                            />
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>

                {isLoading ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(10)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody className="text-sm mt-4 font-medium text-black">
                    {customers.length > 0 ? (
                      <>
                        {customers.map((customer) => (
                          <tr key={customer.id} className="px-6 py-2 bg-white">
                            <td
                              onClick={() => {
                                if (
                                  customer.status.label == 'suspended' ||
                                  customer.status.label == 'archived' ||
                                  customer.status.label == 'active' ||
                                  filter == 'suspended' ||
                                  filter == 'archived'
                                ) {
                                  dispatch(clearAgentName());
                                  let redirectState = {
                                    path: `/team-member-details/${customer.user_id}`,
                                    state: {
                                      from: location.pathname,
                                      historyStack: [
                                        ...(location.state?.historyStack || []),
                                        location.pathname,
                                      ],
                                    },
                                  };
                                  sessionStorage.setItem(
                                    'redirectAfterLogin',
                                    JSON.stringify(redirectState),
                                  );
                                  navigate(
                                    `/team-member-details/${customer.user_id}`,
                                    {
                                      state: {
                                        from: location.pathname,
                                        historyStack: [
                                          ...(location.state?.historyStack ||
                                            []),
                                          location.pathname,
                                        ],
                                      },
                                    },
                                  );
                                }
                                if (
                                  customer.status.label == 'to_review' ||
                                  customer.status.label == 'in_progress' ||
                                  customer.status.label == 'resubmit' ||
                                  customer.status.label ===
                                    'sent_for_resubmit' ||
                                  customer.status.label === 'sent_for_approval'
                                ) {
                                  dispatch(
                                    setOnboardingCustomer(customer.user_id),
                                  );
                                  let redirectState = {
                                    path: `/review-kyc-team-member/${customer.user_id}`,
                                    state: {
                                      from: location.pathname,
                                      historyStack: [
                                        ...(location.state?.historyStack || []),
                                        location.pathname,
                                      ],
                                    },
                                  };
                                  sessionStorage.setItem(
                                    'redirectAfterLogin',
                                    JSON.stringify(redirectState),
                                  );
                                  navigate(
                                    `/review-kyc-team-member/${customer.user_id}`,
                                    {
                                      state: {
                                        from: location.pathname,
                                        historyStack: [
                                          ...(location.state?.historyStack ||
                                            []),
                                          location.pathname,
                                        ],
                                      },
                                    },
                                  );
                                }
                              }}
                              className={`${
                                customer.status.label != 'onboarding' &&
                                customer.status.label != 'pending'
                                  ? 'cursor-pointer'
                                  : ''
                              } px-4 py-6 border-b border-t border border-r-0 rounded-l-xl  text-left min-w-[200px] max-w-[auto] font-medium flex items-center space-x-2`}
                            >
                              <div
                                className={`w-10 h-10 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                                  customer.full_name,
                                )}`}
                              >
                                {getInitials(customer.full_name)}
                              </div>
                              <span
                                className={`${
                                  customer.status.label != 'onboarding' &&
                                  customer.status.label != 'pending'
                                    ? 'underline cursor-pointer'
                                    : ''
                                } text-left`}
                              >
                                {customer.full_name}
                              </span>
                            </td>
                            <td className="px-4 py-2 w-40 border-b border-t relative">
                              {customer.email_address}
                            </td>
                            <td className="px-4 w-20 border-b border-t text-center py-2">
                              <button
                                className={` w-40 text-center  font-medium h-10 rounded-xl text-xs px-2 py-2  flex justify-center items-center focus:outline-none${
                                  customer.status.label == 'active'
                                    ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                                    : ''
                                }
                              ${
                                customer.status.label == 'onboarding'
                                  ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                  : ''
                              }
                                 ${
                                   customer.status.label == 'draft'
                                     ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                     : ''
                                 }
                            ${
                              customer.status.label == 'to_review'
                                ? ' text-[#F77E27] bg-[#F77E27] bg-opacity-20'
                                : ''
                            }
                                ${
                                  customer.status.label == 'in_progress'
                                    ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                    : ''
                                }
                                 ${
                                   customer.status.label == 'pending'
                                     ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                     : ''
                                 }
                                ${
                                  customer.status.label == 'resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_approval'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                  ${
                                    customer.status.label == 'rejected'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
                                    ${
                                      customer.status.label == 'blocked'
                                        ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                        : ''
                                    }
                                   ${
                                     customer.status.label == 'deleted'
                                       ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                       : ''
                                   }
                               ${
                                 customer.status.label == 'suspended'
                                   ? ' text-white bg-[#FF5050]'
                                   : ''
                               }
                               ${
                                 customer.status.label == 'closed'
                                   ? ' text-[#000000] bg-[#000000] bg-opacity-20'
                                   : ''
                               }
                                ${
                                  customer.status.label == 'archived'
                                    ? ' text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20'
                                    : ''
                                }
                              `}
                              >
                                <span className="mr-6 text-center">
                                  {customer.status?.label
                                    .replace(/_/g, ' ')
                                    .replace(/\b\w/g, (char) =>
                                      char.toUpperCase(),
                                    )}
                                </span>
                              </button>
                            </td>
                            <td className="px-4 py-2 border-b border-t rounded-r border-l-0 text-ellipsis border overflow-hidden whitespace-nowrap">
                              <div className="flex items-center px-2 space-x-2">
                                <img
                                  src="/clock.svg"
                                  alt="Time Icon"
                                  className="h-4 w-4"
                                />
                                <span className="rounded-xl">
                                  {formatDateTimeUTC(customer.created_at)}
                                </span>
                              </div>
                            </td>
                            <td className="px-4 py-3 border-b border-t border-l-0 rounded-r-xl border rounded-r">
                              <div className="flex items-center gap-2">
                                {/* BLOCK */}
                                {customer.status?.label !== 'blocked' && (
                                  <button
                                    onClick={() => {
                                      setSelectedUserId(customer.user_id);
                                      setReason('');
                                      setError('');
                                      setShowBlockModal(true);
                                    }}
                                    className="
  group inline-flex items-center gap-1.5 rounded-full
  border border-slate-200 bg-white px-3.5 py-1.5
  text-xs sm:text-sm font-medium text-slate-700
  shadow-sm transition-all duration-200
  hover:border-[#375AE7] hover:text-[#375AE7]
  hover:bg-[#375AE7]/5 hover:shadow-md active:scale-95
  "
                                  >
                                    <Ban size={14} />
                                    Block
                                  </button>
                                )}

                                {/* UNBLOCK */}
                                {customer.status?.label === 'blocked' && (
                                  <button
                                    onClick={(e) => {
                                      setLoading(true);
                                      handleUpdateApplication(
                                        e,
                                        'unblock',
                                        customer.user_id,
                                      );
                                    }}
                                    className="
        group
        inline-flex
        items-center
        gap-1.5
        rounded-full
        border
        border-slate-200
        bg-white
        px-3.5
        py-1.5
        text-xs
        sm:text-sm
        font-medium
        text-slate-700
        shadow-sm
        transition-all
        duration-200
        hover:border-[#375AE7]
        hover:text-[#375AE7]
        hover:bg-[#375AE7]/5
        hover:shadow-md
        active:scale-95
        "
                                  >
                                    <RotateCcw
                                      size={14}
                                      className="transition-transform group-hover:scale-110"
                                    />
                                    Unblock
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td colSpan="5">
                          <div className="flex flex-col items-center justify-center py-20 px-6 bg-white rounded-2xl text-center">
                            {/* ICON */}
                            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-blue-50 mb-5">
                              <UserRoundX
                                className="w-7 h-7 text-[#375AE7]"
                                strokeWidth={1.8}
                              />
                            </div>

                            {/* TITLE */}
                            <h3 className="text-base font-semibold text-gray-800">
                              No team members available
                            </h3>

                            {/* DESCRIPTION */}
                            <p className="text-sm font-normal text-gray-500 mt-2 max-w-md">
                              {searchQuery
                                ? `No team members found for "${searchQuery}".`
                                : 'There are currently no team members available. Any new additions will appear here.'}
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>
            </div>

            {customers.length > 0 && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{' '}
                  {currentPage === totalPages || totalPages == 0
                    ? totalCount
                    : Math.max(
                        showRecords * currentPage,
                        customers.length,
                      )}{' '}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2),
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? 'bg-[#375AE7] text-white'
                              : 'bg-white border border-gray-300 text-black'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    },
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {roleName == 'auditor' && (
        <div className="w-full  p-4 bg-white rounded-lg shadow-lg  relative">
          <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img
                src="/customer-black.svg"
                alt="Company Logo"
                className="mr-3"
              />
              <span className="font-medium lg:text-xl text-sm">
                Team Member List
              </span>
            </div>
          </div>
          <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
            <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
              <div className="flex items-center space-x-2">
                <span className="lg:text-md  text-sm text-[#8C8C8C]">
                  Show Records
                </span>
                <Dropdown
                  label=""
                  options={filterOptions}
                  preselectedValue={preSelectedFilter}
                  onSelect={handleFilterChange}
                />
              </div>
              <div className="flex items-center">
                <div className="relative">
                  <input
                    type="text"
                    className="p-2 pl-6 text-sm border rounded-xl"
                    placeholder="Search Team Member"
                    value={searchQuery}
                    onChange={(e) => {
                      setCurrentPage(1);
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <span className="absolute left-2 top-3 text-gray-500">
                    {' '}
                    <img
                      src="/search-normal.svg"
                      alt="Company Logo"
                      className="mr-2"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div>
            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full h-full table-auto w-full border-separate border-spacing-y-4 border-spacing-x-0">
                {/* Table Header */}
                <thead className="text-[#8C8C8C] bg-[#F9F9F9] text-sm">
                  <tr>
                    {pendingHeaders.map((header, index) => (
                      <th
                        onClick={() => handleSort(header.key)}
                        key={header.label}
                        className={`
          cursor-pointer font-medium px-4 py-4 border text-left
          ${index === 0 ? 'rounded-l-xl' : ''}
          ${index === pendingHeaders.length - 1 ? 'rounded-r-xl' : ''}
        `}
                      >
                        <div className="flex items-center justify-between w-full">
                          <span>{header.label}</span>

                          {header.key !== '' && (
                            <img
                              src="/sort.svg"
                              alt="Sort Icon"
                              className="w-4 h-4 ml-auto"
                            />
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>

                {isLoading ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(10)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody className="text-sm mt-4 font-medium text-black">
                    {customers.length > 0 ? (
                      <>
                        {customers.map((customer) => (
                          <tr key={customer.id} className="px-6 py-2 bg-white">
                            <td
                              className={`px-4 py-6 border-b border-t border-l border-r-0 rounded-l-xl text-left min-w-[200px] max-w-[auto] font-medium flex items-center space-x-2`}
                            >
                              <div
                                className={`w-10 h-10 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                                  customer.full_name,
                                )}`}
                              >
                                {getInitials(customer.full_name)}
                              </div>
                              <span className={`text-left`}>
                                {customer.full_name}
                              </span>
                            </td>
                            <td className="px-4 py-2 w-40 border-b border-t relative">
                              {customer.email_address}
                            </td>
                            <td className="px-4 w-20 border-b border-t text-center py-2">
                              <button
                                className={` w-40 text-center  font-medium h-10 rounded-xl text-xs px-2 py-2  flex justify-center items-center focus:outline-none${
                                  customer.status.label == 'active'
                                    ? ' text-[#34C046] bg-[#34C046] bg-opacity-20'
                                    : ''
                                }
                              ${
                                customer.status.label == 'onboarding'
                                  ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                  : ''
                              }
                                 ${
                                   customer.status.label == 'draft'
                                     ? ' text-[#375AE7] bg-[#375AE7] bg-opacity-20'
                                     : ''
                                 }
                            ${
                              customer.status.label == 'to_review'
                                ? ' text-[#F77E27] bg-[#F77E27] bg-opacity-20'
                                : ''
                            }
                                ${
                                  customer.status.label == 'in_progress'
                                    ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                    : ''
                                }
                                 ${
                                   customer.status.label == 'pending'
                                     ? ' text-[#FFC421] bg-[#FFC421] bg-opacity-20'
                                     : ''
                                 }
                                ${
                                  customer.status.label == 'resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_resubmit'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                ${
                                  customer.status.label == 'sent_for_approval'
                                    ? ' text-[#3047EC] bg-[#3047EC] bg-opacity-20'
                                    : ''
                                }
                                  ${
                                    customer.status.label == 'rejected'
                                      ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                      : ''
                                  }
                                    ${
                                      customer.status.label == 'blocked'
                                        ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                        : ''
                                    }
                                   ${
                                     customer.status.label == 'deleted'
                                       ? ' text-[#FF5050] bg-[#FF5050] bg-opacity-20'
                                       : ''
                                   }
                               ${
                                 customer.status.label == 'suspended'
                                   ? ' text-white bg-[#FF5050]'
                                   : ''
                               }
                               ${
                                 customer.status.label == 'closed'
                                   ? ' text-[#000000] bg-[#000000] bg-opacity-20'
                                   : ''
                               }
                                ${
                                  customer.status.label == 'archived'
                                    ? ' text-[#A6A6A6] bg-[#A6A6A6] bg-opacity-20'
                                    : ''
                                }
                              `}
                              >
                                <span className="mr-6 text-center">
                                  {customer.status?.label
                                    .replace(/_/g, ' ')
                                    .replace(/\b\w/g, (char) =>
                                      char.toUpperCase(),
                                    )}
                                </span>
                              </button>
                            </td>
                            <td className="px-4 py-2 border-b border-t  border-r rounded-r-xl border-l-0 text-ellipsis border overflow-hidden whitespace-nowrap">
                              <div className="flex items-center px-2 space-x-2">
                                <img
                                  src="/clock.svg"
                                  alt="Time Icon"
                                  className="h-4 w-4"
                                />
                                <span className="rounded-xl">
                                  {formatDateTimeUTC(customer.created_at)}
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <tr>
                        <td colSpan="5">
                          <div className="flex flex-col items-center justify-center py-20 px-6 bg-white rounded-2xl text-center">
                            {/* ICON */}
                            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-blue-50 mb-5">
                              <UserRoundX
                                className="w-7 h-7 text-[#375AE7]"
                                strokeWidth={1.8}
                              />
                            </div>

                            {/* TITLE */}
                            <h3 className="text-base font-semibold text-gray-800">
                              No team members available
                            </h3>

                            {/* DESCRIPTION */}
                            <p className="text-sm font-normal text-gray-500 mt-2 max-w-md">
                              {searchQuery
                                ? `No team members found for "${searchQuery}".`
                                : 'There are currently no team members available. Any new additions will appear here.'}
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>
            </div>

            {customers.length > 0 && (
              <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                {/* Entries Info Section */}
                <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                  Showing {showRecords * (currentPage - 1) + 1} to{' '}
                  {currentPage === totalPages || totalPages == 0
                    ? totalCount
                    : Math.max(
                        showRecords * currentPage,
                        customers.length,
                      )}{' '}
                  of {totalCount} entries
                </div>

                {/* Pagination Section */}
                <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                  {/* Previous Button */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Prev
                  </button>

                  {/* Page Buttons */}
                  {Array.from({ length: Math.min(totalPages, 5) }).map(
                    (_, index) => {
                      const startPage = Math.max(
                        1,
                        Math.min(totalPages - 4, currentPage - 2),
                      );
                      const page = startPage + index;

                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded ${
                            currentPage === page
                              ? 'bg-[#375AE7] text-white'
                              : 'bg-white border border-gray-300 text-black'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    },
                  )}

                  {/* Next Button */}
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {showBlockModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div
            className="
      w-full max-w-md rounded-2xl bg-white p-6
      shadow-[0_20px_60px_-15px_rgba(0,0,0,0.25)]
      animate-in fade-in zoom-in-95
    "
          >
            {/* Header */}
            <h2 className="text-lg font-semibold text-slate-900">
              Confirm Block
            </h2>

            <p className="mt-1 text-sm text-slate-500">
              Please provide a reason for blocking this user.
            </p>

            {/* Textarea */}
            <textarea
              value={reason}
              maxLength={200}
              minLength={10}
              onChange={(e) => {
                setReason(e.target.value);
                if (e.target.value.length >= 10) setError('');
              }}
              placeholder="Enter reason (minimum 10 characters)..."
              className="
        mt-4 w-full rounded-xl border border-slate-200
        p-3 text-sm outline-none transition
        focus:border-[#375AE7] focus:ring-2 focus:ring-[#375AE7]/20
        "
              rows={4}
            />

            {/* Error */}
            {error && <p className="mt-2 text-xs text-red-500">{error}</p>}

            {/* Footer */}
            <div className="mt-5 flex justify-end gap-3">
              <button
                onClick={() => setShowBlockModal(false)}
                className="
          rounded-full border border-slate-200 px-4 py-2
          text-sm text-slate-600 hover:bg-slate-100
          "
              >
                Cancel
              </button>

              <button
                onClick={(e) => {
                  if (reason.trim().length < 10) {
                    setError('Reason must be at least 10 characters.');
                    return;
                  }

                  setLoading(true);
                  handleUpdateApplication(
                    e,
                    'block',
                    selectedUserId,
                    reason, // ✅ pass reason
                  );

                  setShowBlockModal(false);
                }}
                disabled={reason.trim().length < 10}
                className={`
          rounded-full px-4 py-2 text-sm font-medium text-white
          transition-all
          ${
            reason.trim().length >= 10
              ? 'bg-[#375AE7] hover:bg-[#2f4fd1]'
              : 'bg-slate-300 cursor-not-allowed'
          }
          `}
              >
                Confirm Block
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgentList;
